/* Sri Ram Exporters — theme behaviours
   Header state, mobile menu, scroll reveals, parallax, product
   gallery + variant picker, quantity steppers.
   Everything degrades gracefully without JavaScript. */
(() => {
  'use strict';
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ----- Header: solid state on scroll (home transparent header) ----- */
  const header = document.querySelector('.header');
  if (header && header.hasAttribute('data-transparent')) {
    const setState = () => header.classList.toggle('is-solid', window.scrollY > 24);
    window.addEventListener('scroll', setState, { passive: true });
    setState();
  }

/* ----- Mobile menu ----- */
const menu = document.getElementById('MobileMenu');
const setExpanded = (on) => { document.querySelectorAll('[data-menu-open]').forEach((b) => b.setAttribute('aria-expanded', on ? 'true' : 'false')); };
const openMenu = () => { if (menu) { menu.classList.add('is-open'); document.body.style.overflow = 'hidden'; setExpanded(true); const c = menu.querySelector('[data-menu-close]'); if (c) c.focus(); } };
const closeMenu = () => { if (menu) { menu.classList.remove('is-open'); document.body.style.overflow = ''; setExpanded(false); } };
document.addEventListener('click', (e) => { if (e.target.closest('[data-menu-open]')) { e.preventDefault(); openMenu(); } else if (e.target.closest('[data-menu-close]')) { e.preventDefault(); closeMenu(); } else if (menu && menu.classList.contains('is-open') && e.target.closest('a')) { closeMenu(); } });
document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeMenu(); });

  /* ----- Scroll reveals ----- */
  const initReveals = () => {
    const els = document.querySelectorAll('[data-reveal]:not([data-reveal-ready])');
    if (!els.length) return;
    if (reduce || !('IntersectionObserver' in window)) {
      els.forEach((el) => { el.setAttribute('data-reveal-ready', ''); el.classList.add('is-in'); });
      return;
    }
    const io = new IntersectionObserver((entries) => {
      for (const entry of entries) {
        if (entry.isIntersecting) { entry.target.classList.add('is-in'); io.unobserve(entry.target); }
      }
    }, { threshold: 0, rootMargin: '0px 0px -8% 0px' });
    els.forEach((el) => { el.setAttribute('data-reveal-ready', ''); io.observe(el); });
  };
  initReveals();
  document.addEventListener('shopify:section:load', initReveals);

  /* ----- Parallax ----- */
  if (!reduce) {
    const els = Array.from(document.querySelectorAll('[data-parallax]'));
    if (els.length) {
      let ticking = false;
      const update = () => {
        ticking = false;
        const vh = window.innerHeight;
        for (const el of els) {
          const r = el.getBoundingClientRect();
          if (r.bottom < 0 || r.top > vh) continue;
          const p = (r.top + r.height / 2 - vh / 2) / vh;
          const depth = parseFloat(el.dataset.parallax) || 6;
          el.style.transform = `translateY(${(p * depth).toFixed(2)}%) scale(1.12)`;
        }
      };
      window.addEventListener('scroll', () => {
        if (!ticking) { ticking = true; requestAnimationFrame(update); }
      }, { passive: true });
      update();
    }
  }

  /* ----- Quantity steppers ----- */
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-qty]');
    if (!btn) return;
    const input = btn.parentElement.querySelector('input');
    if (!input) return;
    const step = btn.dataset.qty === 'up' ? 1 : -1;
    const min = parseInt(input.min || '1', 10);
    input.value = Math.max(min, (parseInt(input.value, 10) || min) + step);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ----- Product gallery ----- */
  const gallery = document.querySelector('[data-gallery]');
  if (gallery) {
    const main = gallery.querySelector('[data-gallery-main] img');
    gallery.querySelectorAll('[data-gallery-thumb]').forEach((thumb) => {
      thumb.addEventListener('click', () => {
        const img = thumb.querySelector('img');
        if (!main || !img) return;
        main.src = thumb.dataset.src || img.src;
        main.srcset = thumb.dataset.srcset || '';
        main.alt = img.alt || '';
        gallery.querySelectorAll('[data-gallery-thumb]').forEach((t) => t.setAttribute('aria-current', 'false'));
        thumb.setAttribute('aria-current', 'true');
      });
    });
  }

  /* ----- Variant picker ----- */
  const form = document.querySelector('[data-product-form]');
  const dataEl = document.getElementById('ProductVariants');
  if (form && dataEl) {
    let variants = [];
    try { variants = JSON.parse(dataEl.textContent); } catch (err) { variants = []; }
    const selects = Array.from(form.querySelectorAll('[data-option-select]'));
    const idInput = form.querySelector('input[name="id"]');
    const priceEl = document.querySelector('[data-product-price]');
    const compareEl = document.querySelector('[data-product-compare]');
    const buyBtn = form.querySelector('[data-buy-button]');

    const moneyFormat = (cents) => {
      const fmt = dataEl.dataset.money || '${{amount}}';
      const amount = (cents / 100).toFixed(2);
      return fmt.replace(/\{\{\s*amount[^}]*\}\}/, amount);
    };

    const sync = () => {
      const chosen = selects.map((s) => s.value);
      const match = variants.find((v) => chosen.every((val, i) => v.options[i] === val));
      if (!match) return;
      if (idInput) idInput.value = match.id;
      if (priceEl) priceEl.textContent = moneyFormat(match.price);
      if (compareEl) {
        if (match.compare_at_price && match.compare_at_price > match.price) {
          compareEl.textContent = moneyFormat(match.compare_at_price);
          compareEl.hidden = false;
        } else {
          compareEl.hidden = true;
        }
      }
      if (buyBtn) {
        buyBtn.disabled = !match.available;
        buyBtn.textContent = match.available ? buyBtn.dataset.labelAdd : buyBtn.dataset.labelSold;
      }
    };
    selects.forEach((s) => s.addEventListener('change', sync));
    sync();
  }
})();
